import reportStorage from '../storage/reportsStorage'

export default {
  cleanStorage () {
    reportStorage.cleanStorage()
  }
}



// WEBPACK FOOTER //
// ./src/utils/storageCleaner.js